export { default } from './BoxSettingsSideBar'
